import {
  AspectRatio,
  Box,
  Flex,
  HStack,
  ListItem,
  SimpleGrid,
  Text,
  UnorderedList,
  VStack
} from '@chakra-ui/react'
import Image from 'next/image'

const Item = ({
  title,
  src,
  ratio = 1 / 1
}: {
  title: string
  src: any
  ratio?: any
}) => {
  return (
    <VStack gap={2}>
      <VStack w="100%" justifyContent="center">
        <AspectRatio
          w={{
            base: '40px',
            sm: '50px',
            xl: '60px'
          }}
          ratio={ratio}
          position="relative"
        >
          <Image src={src} alt={title} fill />
        </AspectRatio>
      </VStack>
      <Text
        lineHeight={1.1}
        fontSize={{
          base: '10px',
          sm: '12px'
        }}
        textAlign="center"
        fontFamily="Inter"
        fontWeight={500}
        zIndex={100}
        maxW="150px"
      >
        {title}
      </Text>
    </VStack>
  )
}

const HowToUse = () => {
  return (
    <VStack w="100%" alignItems="center">
      <Flex
        data-aos="fade-up"
        w={{
          base: '90%',
          sm: '80%',
          md: '100%',
          lg: '100%'
        }}
        gap={{
          base: 4,
          sm: 4,
          md: 6
        }}
        mt={10}
        flexDir={{
          base: 'column',
          md: 'row'
        }}
      >
        <VStack
          w={{
            base: '100%',
            md: '40%'
          }}
          position="relative"
          alignItems={{
            base: 'center',
            md: 'flex-end'
          }}
        >
          <AspectRatio
            w={{
              base: '60%',
              md: '80%'
            }}
            ratio={688 / 960}
            position="relative"
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/three-bottle-1715151284733.png'
              }
              alt="group bottle"
              fill
            />
          </AspectRatio>

          <Flex
            w={{
              base: '110px',
              md: '120px',
              lg: '150px'
            }}
            h={{
              base: '110px',
              md: '120px',
              lg: '150px'
            }}
            position="absolute"
            top="0px"
            left="0px"
            zIndex={100}
            bgColor="#9cb259"
            borderRadius="9999px"
            justifyContent="center"
            alignItems="center"
            flexDir="column"
          >
            <Text
              textStyle="oralcareFeaTittleLarge"
              textAlign="center"
              fontWeight={700}
              w={{
                base: '90%',
                sm: '80%'
              }}
              zIndex={100}
            >
              Easy Gargle Formula
            </Text>
            <Text
              textStyle="oralcareFeaTittle"
              textAlign="center"
              fontWeight={400}
              w={{
                base: '90%',
                sm: '80%'
              }}
              zIndex={100}
            >
              No more burning sensation
            </Text>
          </Flex>

          <Flex
            w={{
              base: '150px',
              sm: '150px',
              md: '150px',
              lg: '180px'
            }}
            position="absolute"
            bottom={{
              base: '-20px',
              md: '70px',
              lg: 0,
              xl: '20px'
            }}
            left={{
              base: 0,
              sm: '50px',
              md: 0
            }}
            zIndex={100}
            justifyContent="center"
            alignItems="center"
            flexDir="column"
          >
            <AspectRatio
              w={{
                base: '100%',
                md: '90%'
              }}
              ratio={1537 / 864}
              position="relative"
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/htuse-one-1714038420073.png'
                }
                alt="icon"
                fill
              />
            </AspectRatio>
          </Flex>

          <Flex
            w={{
              base: '150px',
              sm: '150px',
              md: '150px',
              lg: '180px'
            }}
            position="absolute"
            bottom={{
              base: '-20px',
              md: '70px',
              lg: 0,
              xl: '20px'
            }}
            right={{
              base: 0,
              sm: '20px',
              md: '-30px',
              lg: '-30px'
            }}
            zIndex={100}
            justifyContent="center"
            alignItems="center"
            flexDir="column"
          >
            <AspectRatio
              w={{
                base: '100%',
                md: '80%'
              }}
              ratio={1537 / 864}
              position="relative"
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/htuse-two-1714038420074.png'
                }
                alt="icon"
                fill
              />
            </AspectRatio>
          </Flex>
        </VStack>
        <Box
          w={{
            base: '100%',
            md: '55%'
          }}
          mt={{
            base: 10,
            md: '0'
          }}
        >
          <Text
            textStyle="oralcareEffectivenessTittle"
            textAlign="center"
            textTransform="uppercase"
            color="#4B7438"
            mt={{
              base: 2,
              md: 4,
              xl: 10
            }}
          >
            How To Use
          </Text>
          <UnorderedList
            fontSize={{
              base: '12px',
              sm: '16px',
              md: '18px',
              lg: '20px'
            }}
            lineHeight={{
              base: 1.3,
              md: 1.4
            }}
            textAlign="left"
            fontWeight={400}
            zIndex={100}
            mt={4}
          >
            <ListItem>
              Use one cap of Health+ OralCare Mouthwash per session.
            </ListItem>
            <ListItem>
              Include it in your routine at any time or post-brushing.
            </ListItem>
            <ListItem>
              Pour into the cap before Transferring to your mouth.
            </ListItem>
            <ListItem>Gargle for at least 30 seconds. </ListItem>
            <ListItem>
              Spit out to witness debris removal, which is more noticeable after
              oily meals.
            </ListItem>
            <ListItem>
              Optional: Rinse if desired; not mandatory for full benefits.
            </ListItem>
          </UnorderedList>

          <SimpleGrid
            columns={5}
            gap={2}
            w={{
              base: '100%',
              md: '100%'
            }}
            mt={5}
          >
            <Item
              ratio={1537 / 864}
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/htu-fea-one-1714038420070.png'
              }
              title="One cap per use"
            />
            <Item
              ratio={1537 / 864}
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/htu-fea-two-1714038420073.png'
              }
              title="After brushing your teeth"
            />
            <Item
              ratio={1537 / 864}
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/htu-fea-three-1714038420072.png'
              }
              title="Gargle 30 seconds"
            />
            <Item
              ratio={1537 / 864}
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/htu-fea-four-1714038420069.png'
              }
              title="Spit out"
            />
            <Item
              ratio={1537 / 864}
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/htu-fea-five-1714038420068.png'
              }
              title="Feel the refreshes"
            />
          </SimpleGrid>
        </Box>
      </Flex>

      <Flex
        data-aos="fade-up"
        w={{
          base: '90%',
          sm: '80%',
          md: '100%',
          lg: '100%'
        }}
        gap={{
          base: 4,
          sm: 4,
          md: 6
        }}
        mt={{
          base: 10,
          md: '100px'
        }}
        flexDir={{
          base: 'column',
          md: 'row'
        }}
      >
        <VStack
          w={{
            base: '100%',
            md: '50%'
          }}
          position="relative"
          mt={10}
        >
          <Text
            textStyle="oralcareHTUTittle"
            textAlign="left"
            textTransform="uppercase"
            color="#4B7438"
            mt={{
              base: 2,
              md: 4,
              xl: 10
            }}
          >
            Reliable certification material
          </Text>
          <UnorderedList
            pl={5}
            w="100%"
            fontSize={{
              base: '12px',
              sm: '16px',
              md: '18px',
              lg: '20px'
            }}
            lineHeight={{
              base: 1.3,
              md: 1.4
            }}
            fontWeight={400}
            zIndex={100}
            mt={4}
          >
            <ListItem>Ecocert certification </ListItem>
            <ListItem>Permission to use Jeju city ticket</ListItem>
            <ListItem>Ethanol-free test report</ListItem>
          </UnorderedList>

          <HStack w="100%" mt={4}>
            <AspectRatio
              w={{
                base: '120px',
                md: '200px'
              }}
              ratio={1390 / 864}
              position="relative"
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/korea-flag-1714038420074.png'
                }
                alt="korea flag"
                fill
                style={{
                  border: '3px solid #000'
                }}
              />
            </AspectRatio>
            <AspectRatio
              w={{
                base: '120px',
                md: '200px'
              }}
              ratio={1537 / 864}
              position="relative"
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/cer-hsa-1714038420075.png'
                }
                alt="cer hsa"
                fill
              />
            </AspectRatio>
          </HStack>
        </VStack>
        <VStack
          w={{
            base: '100%',
            md: '50%'
          }}
          justifyContent="flex-end"
        >
          <AspectRatio
            w={{
              base: '100%',
              md: '320px',
              lg: '400px'
            }}
            ratio={567 / 864}
            position="relative"
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/certification-1714038420075.png'
              }
              alt="certification"
              fill
            />
          </AspectRatio>
        </VStack>
      </Flex>
    </VStack>
  )
}

export default HowToUse
